
import { useState } from "react";
import "../components/mediaq.css"
function About() {
  const [exp, setExp] = useState(true);
  const [ski, setSkills] = useState(false);
  const [pro, setProj] = useState(false);
  const [ed, setEd] = useState(false);
  const [cor, setCor] = useState(false);

  return (
    <div id="about-container">
      <h2>About ME</h2>
      <div id="about-option">
        <ul style={{ listStyleType: "none" }}>
          <li
            onClick={() =>
              setExp(true) &
              setSkills(false) &
              setProj(false) &
              setEd(false) &
              setCor(false)
            }
          >
            Experience
          </li>
          <li
            onClick={() =>
              setExp(false) &
              setSkills(true) &
              setProj(false) &
              setEd(false) &
              setCor(false)
            }
          >
            Skills
          </li>
          <li
            onClick={() =>
              setExp(false) &
              setSkills(false) &
              setProj(true) &
              setEd(false) &
              setCor(false)
            }
          >
            Projects
          </li>
          <li
            onClick={() =>
              setExp(false) &
              setSkills(false) &
              setProj(false) &
              setEd(true) &
              setCor(false)
            }
          >
            Education
          </li>
          <li
            onClick={() =>
              setExp(false) &
              setSkills(false) &
              setProj(false) &
              setEd(false) &
              setCor(true)
            }
          >
            Courses
          </li>
        </ul>
      </div>
      <div id="about-card">
        {exp ? (
          <div className="item exp">
            <p>SAP EWM Functional Consultant @ Artihcus Global [Feb 2022- till date]</p>
            <li>Executed 2 end-to-end SAP EWM implementations, 1 rollout, and supported 2 projects,ensuring successful go-live and post-go-live stability.</li>
            <li>Gathered business requirements and configured SAP EWM processes including inbound, outbound, internal warehouse movements, and inventory management.</li>
            <li>Collaborated with cross-functional teams to perform system configuration, testing (SIT/UAT), and issue resolution, ensuring seamless warehouse operations.</li>

            <p>Data Analyst @ Jobiak [Sep 2018- March 2019] </p>
            <li>Data analysis of types of career pages of companies.</li>
            <li>Product testing with different test cases.</li>
            <li>
              Data collection for different cases used for software development 
            </li>
          </div>
        ) : null}
        {ski ? (
          <div className="item skills">
             <p>SAP EWM Embedded & decentralised</p>
            <p>Javascript</p>
            <p>HTML & CSS</p>
            <p>React.js</p>
            <p>JQuery</p>
            <p>Node.js</p>
            <p>Bootstrap</p>
          </div>
        ) : null}
        {pro ? (
          <div className="item projects">
            <p>Bajaj Auto - Implementation project </p>
            <p>Vishal Mega Mart - Support Project</p>
            <p>Somany ceramics - Implementation and Rollout project</p>
            <p>IFFCO Dubai - Support Project </p>
          </div>
        ) : null}

        {ed ? (
          <div className="item education">
            <p>MBA-HR @ Dr.Lankapalli Bullayya College [2019-2021]</p>
            <p>
              B.Tech-Computer Science & Engineering @ Vignan's institute of
              information & Technology [2014-2018]
            </p>
            <p>Intermediate(11th & 12th) @ Narayana College [2012-2014]</p>
            <p>High School (10th) @ Pollocks School [2012]</p>
          </div>
        ) : null}

        {cor ? (
          <div className="item courses">
            <p>Udemy Web development Course By Angela </p>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default About;
